import React from 'react';
import moment from 'moment';

const ParseTimeframeForReport = (timeframe, timeframeUnit) => {
    let parsedTimeframeUnit = `(null)`;
    if (typeof timeframeUnit === 'string') {
        parsedTimeframeUnit = {
            mi: `minute`,
            h: `hour`,
            d: `day`,
            w: `week`,
            mo: `month`,
            y: `year`,
            i: `Immediate`,
        }[timeframeUnit];
        return `${timeframeUnit === 'i' ? `` : `${timeframe} `}${parsedTimeframeUnit}${parseInt(timeframe) !== 1 && timeframeUnit !== 'i' ? `s` : ``}`;
    }
    return ``;
}

export const ConditionDetailsBuilder = (reportData) => {

    const buildConditionDetails = () => {
        let section = [];
        section.push(<div className="section-header" key="condition-details">Condition Details</div>);
        section.push(
            <div className="data-row" key="code">
                <div className="header one-fourth">Condition Code:</div>
                <div className="one-half">{reportData.conditionDetails.condition_code}</div>
            </div>
        );

        section.push(
            <div className="data-row" key="category">
                <div className="header one-fourth">Category:</div>
                <div className="one-half capitalize">{reportData.conditionDetails.condition_category || <span className="data-row--invalid-data-fallback">Excluded due to invalid data structure.*</span>}</div>
            </div>
        );

        section.push(
            <div className="data-row" key="nnf">
                <div className="header one-fourth">Nationally Notifiable:</div>
                <div className="one-half">{reportData.conditionDetails.nationally_notifiable ? 'Y' : 'N'}</div>
            </div>
        );
        section.push(
            <div className="data-row" key="nnf-code">
                <div className="header one-fourth">NNC Code:</div>
                <div className="one-half">{reportData.conditionDetails.nnc_code !== '' ? reportData.conditionDetails.nnc_code : '---'}</div>
            </div>
        );

        section.push(
            <div className="data-row" key="descr">
                <div className="header one-fourth">Description:</div>
                <div className="one-half capitalize">{reportData.conditionDetails.description ? reportData.conditionDetails.description : '---'}</div>
            </div>
        );

        section.push(
            <div className="data-row" key="resp-agency">
                <div className="header one-fourth">Responsible Agency:</div>
                <div className="one-half">{reportData.conditionDetails.responsibleAgency ? reportData.conditionDetails.responsibleAgency : '---'}</div>
            </div>
        );

        return section;
    };

    const buildReportingSpecificationsStatus = () => {
        let section = [];
        section.push(<div className="section-header" key="spec-status">Reporting Specifications Status</div>);

        section.push(
            <div className="data-row" key="status">
                <div className="header one-fourth">Status:</div>
                <div className="one-half capitalize">{reportData.conditionDetails.status ? reportData.conditionDetails.status.toLowerCase().replace(/_/g, ' ') : '---'}</div>
            </div>
        );
        section.push(
            <div className="data-row" key="version">
                <div className="header one-fourth">Version:</div>
                <div className="one-half capitalize">{reportData.conditionDetails.version}</div>
            </div>
        );

        section.push(
            <div className="data-row" key="start">
                <div className="header one-fourth">Start Date:</div>
                <div className="one-half">{reportData.conditionDetails.start_date ? moment(reportData.conditionDetails.start_date).format("MMM Do YYYY") : '---'}</div>
            </div>
        );
        section.push(
            <div className="data-row" key="end">
                <div className="header one-fourth">End Date:</div>
                <div className="one-half">{reportData.conditionDetails.end_date ? moment(reportData.conditionDetails.end_date).format("MMM Do YYYY") : '---'}</div>
            </div>
        );
        section.push(
            <div className="data-row" key="assigned-to">
                <div className="header one-fourth">Assigned To:</div>
                <div className="one-half capitalize">{reportData.conditionDetails.assignedTo ? reportData.conditionDetails.assignedTo : '---'}</div>
            </div>
        );

        return section;
    };

    const buildReportingPreferences = () => {
        let section = [];

        section.push(<div className="section-header" key="reporting-preferences">Reporting Preferences</div>);

        section.push(
            <div className="data-header" key="pref-header">
                <div className="one-half">Specifications Apply when</div>
                <div className="one-half">Report?</div>
            </div>
        );

        section.push(
            <div className="data-row" key="care">
                <div className="one-half">Care is Provided in jurisdiction</div>
                <div className="one-half capitalize">{reportData.conditionDetails.report_care_provided ? 'Yes' : 'No'}</div>
            </div>
        );

        section.push(
            <div className="data-row" key="lab">
                <div className="one-half">Lab is located in jurisdiction</div>
                <div className="one-half capitalize">{reportData.conditionDetails.report_lab_performed ? 'Yes' : 'No'}</div>
            </div>
        );

        section.push(
            <div className="data-row" key="patient">
                <div className="one-half">Patient is a Resident of a jurisdiction</div>
                <div className="one-half capitalize">{reportData.conditionDetails.report_patient_resident ? 'Yes' : 'No'}</div>
            </div>
        );

        return section;

    };

    const buildLinksTables = () => {
        let section = [];
        if (reportData.linksReferences.length > 0) {
            section.push(<div className="section-header" key="lnr-header">Links and References</div>);

            let table = [];
            // table.push(
            //     <tr className="table-header">
            //         <th>Name</th>
            //         <th>Type</th>
            //         <th>Description</th>
            //         <th>URL</th>
            //         <th>Priority</th>
            //         <th>Category</th>
            //     </tr>
            // );

            for (let reference of reportData.linksReferences) {
                let referenceSection = [];

                referenceSection.push(
                    <div className="data-row" key="name">
                        <div className="one-fifth header">Name</div>
                        <div className="four-fifths">{reference.name}</div>
                    </div>
                );
                referenceSection.push(
                    <div className="data-row" key="type">
                        <div className="one-fifth header">Type</div>
                        <div className="four-fifths capitalize">{reference.type.toLowerCase()}</div>
                    </div>
                );
                referenceSection.push(
                    <div className="data-row" key="descr">
                        <div className="one-fifth header">Description</div>
                        <div className="four-fifths">{reference.description}</div>
                    </div>
                );
                referenceSection.push(
                    <div className="data-row" key="url">
                        <div className="one-fifth header">URL</div>
                        <div className="four-fifths"><a href={reference.url}>{reference.url}</a></div>
                    </div>
                );
                referenceSection.push(
                    <div className="data-row" key="priority">
                        <div className="one-fifth header">Priority</div>
                        <div className="four-fifths capitalize">{typeof reference.priority === 'string' ? reference.priority.toLowerCase().replace(/_/g, ' ') : '---'}</div>
                    </div>
                );
                referenceSection.push(
                    <div className="data-row" key="category">
                        <div className="one-fifth header">Category</div>
                        <div className="four-fifths capitalize">{typeof reference.category === 'string' ? reference.category.toLowerCase().replace(/_/g, ' ').replace('addl', 'additional') : '---'}</div>
                    </div>
                );

                table.push(<div className="reference-section-details" key={`reference-${reference.name}`}>{referenceSection.map(i => i)}</div>)
            }
            // section.push(<div className="reference-section"><div className="horizontal-scroll-view"><table className="reference-table"><tbody>{table.map(i => i)}</tbody></table></div></div>)
            section.push(<div className="" key={`condition-ref-section`}>{table.map(i => i)}</div>)
        }
        return section;
    };

    const buildSpecificationsSummary = () => {

        let section = [];
        let mappedSpecifications = reportData.specifications.map(i => {
            return {
                ...i,
                rel: reportData.criteriaRels.find(v => v.relId === i.relId),
                set: reportData.logicSets.find(v => v.setId === i.setId),
            };
        });

        let uniqueSets = mappedSpecifications.reduce((map, v, i) => {
            if (map.find(s => s.setId === v.setId) === null) {
                map.push(v.set);
            }
            return map;
        }, []);

        let categorizedSpecifications = mappedSpecifications.filter(v => v.set.timeframe > 0).reduce((map, v, i) => {
            if (typeof map[v.rel.criteriaDTO.criteriaType] === 'object') {
                map[v.rel.criteriaDTO.criteriaTypeDTO.code].push(v);
            } else {
                map[v.rel.criteriaDTO.criteriaTypeDTO.code] = [v];
            }
            return map;
        }, {});

        if (Object.keys(categorizedSpecifications).length) {
            section.push(<div className="section-header">Reporting Specifications - Summary</div>);

            for (let key in categorizedSpecifications) {
                section.push(
                    <div className="data-header grey-bg">
                        <div className="one-half capitalize">{key.toLowerCase().replace(/_/g, ' ')}</div>
                    </div>
                );
                let specsByRel = categorizedSpecifications[key].reduce((map, v, i) => {
                    if (typeof map[v.relId] === 'object') {
                        map[v.relId].push(v);
                    } else {
                        map[v.relId] = [v];
                    }
                    return map;
                }, {});
                for (let specs of Object.values(specsByRel)) {
                    let subsection = [];
                    for (let spec of specs) {
                        let timeframe = ParseTimeframeForReport(spec.set.timeframe, spec.set.timeframeUnit);
                        subsection.push(
                            <div className="data-row" key={spec.set.name}>
                                <div className="one-third"></div>
                                <div className="one-third">
                                    <strong>{spec.set.name.toUpperCase()}</strong> - <em>{timeframe}</em>
                                </div>
                                <div className="one-third">
                                    {{ 'S': 'Sufficient', 'N': 'Necessary', 'O': 'Optional' }[spec.value]}
                                </div>
                            </div>
                        );
                    }
                    section.push(
                        <div className="summary-section" key={specs[0].rel.label}>
                            <div className="data-row">
                                <div className="one capitalize grey-bg">{specs[0].rel.label}</div>
                            </div>
                            {subsection.map(i => i)}
                        </div>
                    );
                }
            }
        }

        return section;
    };

    const buildLogicSetDisplay = () => {
        let section = [];


        if (reportData.logicSet.length > 0) {
            section.push(<div className="section-header" key="logic-header">Logic Set Details</div>);

            for (let set of reportData.logicSet) {
                let subsection = [];

                subsection.push(
                    <div className="data-row" key="type">
                        <div className="one-third header">Provider Type:</div>
                        <div className="two-thirds">{set.provider_type}</div>
                    </div>
                );
                subsection.push(
                    <div className="data-row" key="name">
                        <div className="one-third header">Logic Set Name:</div>
                        <div className="two-thirds">{set.logic_set_name.toUpperCase()}</div>
                    </div>
                );

                subsection.push(
                    <div className="data-row" key="timeframe">
                        <div className="one-third header">Reporting Time Frame:</div>
                        <div className="two-thirds">{set.reporting_time_frame}</div>
                    </div>
                );

                subsection.push(
                    <div className="data-row" key="operable">
                        <div className="one-third header">Operable:</div>
                        <div className="two-thirds">{set.operable? 'Yes': 'No'}</div>
                    </div>
                );

                for (let key in set.groupedCriteria) {
                    subsection.push(
                        <div className="data-header capitalize grey-bg one" key={key}>
                            {key.toLowerCase().replace(/_/g, ' ')}
                        </div>
                    );

                    for (let spec of set.groupedCriteria[key]) {
                        subsection.push(
                            <div className="data-row one" key={spec.label}>
                                <div className="two-thirds">
                                    {spec.label}
                                </div>
                                <div className="one-third">
                                    {spec.value}
                                </div>
                            </div>
                        );
                    }
                }
                section.push(<div className="logic-section" key={set.set_id}>{subsection.map(i => i)}</div>);
            }
        }
        return section;
    };

    const buildCriteriaList = () => {
        let section = [];

        let activeCriteria = reportData.criteriaList.filter(v => v.ignore != 'Inactive');

        if (activeCriteria.length > 0) {
            section.push(<div className="section-header" key="criteria-list">Criteria List</div>);

            for (let criteria of activeCriteria) {
                let subsection = [];
                subsection.push(
                    <div className="data-row" key="name">
                        <div className="one-fifth header">Criteria Name:</div>
                        <div className="four-fifths">{criteria.label}</div>
                    </div>
                );
                if (criteria.timebox != 'N/A') {
                    subsection.push(
                        <div className="data-row" key="type">
                            <div className="one-fifth header">Timebox Duration:</div>
                            <div className="capitalize four-fifths">{criteria.timebox}</div>
                        </div>
                    );
                }
                subsection.push(
                    <div className="data-row" key="type">
                        <div className="one-fifth header">Criteria Type:</div>
                        <div className="capitalize four-fifths">{criteria.type}</div>
                    </div>
                );
                subsection.push(
                    <div className="data-row" key="type">
                        <div className="one-fifth header">Implemented:</div>
                        <div className="capitalize four-fifths">{criteria.implemented ? 'Yes' :  'No'}</div>
                    </div>
                );
                subsection.push(
                    <div className="data-row" key="logic">
                        <div className="one-fifth header">Logic:</div>
                        <div className="four-fifths" dangerouslySetInnerHTML={{ __html: criteria.logic }}></div>
                    </div>
                );

                section.push(<div className="criteria-subsection" key={criteria.rel_id}>{subsection.map(i => i)}</div>);
            }
        }
        return section;
    };

    const buildConceptsAndValueSets = () => {
        let section = [];

        if (reportData.conceptsAndValueSets.length > 0) {
            section.push(<div className="section-header" key="concepts-values-sets">Concepts and Value Sets</div>);
            let concepts = [];

            // Group by Concept
            const conceptsGrouped = reportData.conceptsAndValueSets.reduce((agg, val) => {
                const key = JSON.stringify({ concept: val.concept, conceptName: val.conceptName });
                if (agg.get(key)) {
                    agg.set(key, [...agg.get(key), val])
                } else {
                    agg.set(key, [val])
                }
                return agg;
            }, new Map());

            // Group By VS
            for (let [conceptKey, vals] of conceptsGrouped) {
                const grouped = vals.reduce((agg, val) => {
                    if (val.valueSet !== 'N/A' && val.valueSetName !== 'N/A') {
                        const key = JSON.stringify({ valueSet: val.valueSet, valueSetName: val.valueSetName, valueSetVersion: val.profile });
                        if (agg.get(key)) {
                            agg.set(key, [...agg.get(key), val])
                        } else {
                            agg.set(key, [val])
                        }
                    } else {
                        if (agg.get("Direct")) {
                            agg.set("Direct", [...agg.get("Direct"), val])
                        } else {
                            agg.set("Direct", [val])
                        }
                    }
                    return agg;
                }, new Map());
                conceptsGrouped.set(conceptKey, grouped);
            }

            //Resort off concept name
            let sortedConceptsGrouped = new Map([...conceptsGrouped.entries()].sort((a, b) => JSON.parse(a[0]).concept.localeCompare(JSON.parse(b[0]).concept)));


            for (let [conceptKey, conceptGroup] of sortedConceptsGrouped) {
                let conceptSection = { direct: [], vs: [] };
                let concept = JSON.parse(conceptKey);
                let code = concept.concept;
                let name = concept.conceptName;
                for (let [relKey, relGroup] of conceptGroup) {
                    if (relKey !== 'Direct') {
                        let rel = JSON.parse(relKey);
                        let conceptRelSection = [];
                        let vsName = rel.valueSetName;
                        let vsCode = rel.valueSet;
                        let vsVersion = rel.valueSetVersion;
                        conceptRelSection.push(
                            <div className="data-header" key={`data-header-${vsCode}`}>
                                <div className="one-half flex">
                                    <div className="two-thirds">
                                        Code System
                                    </div>
                                    <div className="one-third">
                                        Code
                                    </div>
                                </div>
                                <div className="one-half">
                                    Code Name
                                </div>
                            </div>
                        );
                        for (let codeRel of relGroup) {
                            let relCodeSystem = codeRel.codeSystem;
                            let relCode = codeRel.code;
                            let relName = codeRel.codeName;
                            conceptRelSection.push(
                                <div className="data-row" key={relCode}>
                                    <div className="one-half flex">
                                        <div className="two-thirds">
                                            <div>{relCodeSystem}</div>
                                        </div>
                                        <div className="one-third">
                                            {relCode}
                                        </div>
                                    </div>
                                    <div className="one-half">
                                        {relName}
                                    </div>
                                </div>
                            );
                        }
                        conceptSection.vs.push(
                            <React.Fragment key={`fragment-${vsCode}`}>
                                <div className="data-row" key={`data-row-${vsCode}`}>
                                    <div className="one-half">
                                        {vsCode}
                                    </div>
                                    <div className="one-half">
                                        {vsName} - {vsVersion}
                                    </div>
                                </div>
                                <div className="code-section" key={`code-section-${vsCode}`}>
                                    {conceptRelSection.map(i => i)}
                                </div>
                            </React.Fragment>
                        );
                    } else {
                        for (let rel of relGroup) {
                            conceptSection.direct.push(
                                <div className="data-row" key={rel.code}>
                                    <div className="one-half flex">
                                        <div className="two-thirds">
                                            <div>{rel.codeSystem}</div>
                                        </div>
                                        <div className="one-third">
                                            {rel.code}
                                        </div>
                                    </div>
                                    <div className="one-half">
                                        {rel.codeName}
                                    </div>
                                </div>
                            );
                        }
                    }
                }
                concepts.push(
                    <div className="single-concept" key={code}>
                        <div className="data-row">
                            <div className="one-half">
                                {code}
                            </div>
                            <div className="one-half">
                                {name}
                            </div>
                        </div>
                        <div className="concept-section">
                            {conceptSection.vs.length > 0 &&
                                <div>
                                    <div className="data-header">
                                        <div className="one-half">
                                            Value Set
                                        </div>
                                        <div className="one-half">
                                            VS Name - Version
                                        </div>
                                    </div>
                                    {conceptSection.vs.map(i => i)}
                                </div>
                            }
                            {conceptSection.direct.length > 0 &&
                                <div>
                                    <div className="data-header">
                                        <div className="one-half flex">
                                            <div className="two-thirds">
                                                <div>Code System</div>
                                            </div>
                                            <div className="one-third">
                                                Code
                                            </div>
                                        </div>
                                        <div className="one-half">
                                            Code Name
                                        </div>
                                    </div>
                                    {conceptSection.direct.map(i => i)}
                                </div>
                            }
                        </div>
                    </div>
                );
            }
            section.push(
                <div className="concepts" key="concepts-section">
                    <div className="data-header">
                        <div className="one-half">
                            Concept
                        </div>
                        <div className="one-half">
                            Concept Name
                        </div>
                    </div>
                    {concepts.map(i => i)}
                </div>
            );
        }

        return section;
    };

    const build = () => {
        let report = [];
        report.push(buildConditionDetails());
        report.push(buildReportingSpecificationsStatus());
        report.push(buildReportingPreferences());
        report.push(buildLinksTables());
        // report.push(buildSpecificationsSummary());
        report.push(buildLogicSetDisplay());
        report.push(buildCriteriaList());
        report.push(buildConceptsAndValueSets());

        return report;
    };

    return {
        build
    }

};

export default ConditionDetailsBuilder;
